import { render, staticRenderFns } from "./CustomerItemsChart.vue?vue&type=template&id=1be98664&scoped=true"
import script from "./CustomerItemsChart.vue?vue&type=script&lang=js"
export * from "./CustomerItemsChart.vue?vue&type=script&lang=js"
import style0 from "./CustomerItemsChart.vue?vue&type=style&index=0&id=1be98664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be98664",
  null
  
)

export default component.exports